﻿import Repository from "./Repository";

const burgStandenResource = "family/burgstanden";
const verwantschappenResource = "family/verwantschappen";

export default {
  getBurgStanden() {
    return Repository.get(burgStandenResource);
  },
  getVerwantschappen() {
    return Repository.get(verwantschappenResource);
  },
};
